/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  CreateOrganizationInvite,
  EntityId,
  InviteLinkToCollection,
  InviteLinkToOrganization,
  InviteLinkToSpace,
  InviteUsersToOrganization,
  List,
  MemberRoleOrGuest,
  OrganizationInviteLink,
} from "./data-contracts";

/**
 * No description
 * @tags organization-invites
 * @name InviteUsersToOrganization
 * @summary Invite users in an organization
 * @request POST:/orgs/{organizationId}/invites
 * @secure
 */

// @ts-ignore
export const inviteUsersToOrganization: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: InviteUsersToOrganization;
  RequestHeaders: {};
  ResponseBody: {
    users: string[];
    /** The number of users who were added to the organization */
    invited: number;
    failedSSOEmails?: string[];
  };
  ResponseStatusCode: 200 | 400;
} = {
  route: "/orgs/{organizationId}/invites",
  method: "post",
  streaming: false,
  tags: ["organization-invites"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organization-invites
 * @name JoinOrganizationWithInvite
 * @summary Join an organization with an invite
 * @request POST:/orgs/{organizationId}/invites/{inviteId}
 * @secure
 */

// @ts-ignore
export const joinOrganizationWithInvite: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the invite */
    inviteId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: object;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/invites/{inviteId}",
  method: "post",
  streaming: false,
  tags: ["organization-invites"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organization-invites, internal
 * @name ListOrganizationContentInviteLinks
 * @summary List all content invites
 * @request GET:/orgs/{organizationId}/content-link-invites
 * @secure
 */

// @ts-ignore
export const listOrganizationContentInviteLinks: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** If specified, only return invite links that provide specific permissions on the given space. */
    space?: string;
    /** If specified, only return invite links that provide permissions on the given collection. */
    collection?: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: (InviteLinkToCollection | InviteLinkToSpace)[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/content-link-invites",
  method: "get",
  streaming: false,
  tags: ["organization-invites", "internal"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organization-invites
 * @name ListOrganizationInviteLinks
 * @summary List organization invites
 * @request GET:/orgs/{organizationId}/link-invites
 * @secure
 */

// @ts-ignore
export const listOrganizationInviteLinks: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: InviteLinkToOrganization[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/link-invites",
  method: "get",
  streaming: false,
  tags: ["organization-invites"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organization-invites
 * @name CreateOrganizationInvite
 * @summary Create an organization invite
 * @request POST:/orgs/{organizationId}/link-invites
 * @secure
 */

// @ts-ignore
export const createOrganizationInvite: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: CreateOrganizationInvite;
  RequestHeaders: {};
  ResponseBody: OrganizationInviteLink;
  ResponseStatusCode: 201;
} = {
  route: "/orgs/{organizationId}/link-invites",
  method: "post",
  streaming: false,
  tags: ["organization-invites"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organization-invites
 * @name GetOrganizationInviteLink
 * @summary Get an organization by its ID
 * @request GET:/orgs/{organizationId}/link-invites/{inviteId}
 * @secure
 */

// @ts-ignore
export const getOrganizationInviteLink: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the invite */
    inviteId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: OrganizationInviteLink;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/link-invites/{inviteId}",
  method: "get",
  streaming: false,
  tags: ["organization-invites"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organization-invites
 * @name UpdateOrganizationInviteById
 * @summary Update an organization invite
 * @request PATCH:/orgs/{organizationId}/link-invites/{inviteId}
 * @secure
 */

// @ts-ignore
export const updateOrganizationInviteById: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the invite */
    inviteId: EntityId;
  };
  RequestQuery: {};
  RequestBody:
    | {
        /** The role of a member in an organization, null for guests */
        role: MemberRoleOrGuest;
      }
    | {
        /** The role of a member in an organization, null for guests */
        level: MemberRoleOrGuest;
      };
  RequestHeaders: {};
  ResponseBody: OrganizationInviteLink;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/link-invites/{inviteId}",
  method: "patch",
  streaming: false,
  tags: ["organization-invites"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
